import { BrowserRouter, Route, Routes } from "react-router-dom";

import EditPassword from "components/pages/EditPassword";
import FindId from "components/pages/FindId";
import FindPassword from "components/pages/FindPassword";
import Login from "components/pages/Login";
import Project from "components/pages/Project";
import Projects from "components/pages/Projects";
import SignUp from "components/pages/SignUp";
import BetaSignUp from "components/pages/BetaSignUp";
import Layout from "components/layouts";
import Terms from "components/pages/Terms";
import PrivacyPolicy from "components/pages/PrivacyPolicy";
import Guide from "components/pages/Guide";

import AuthRoute from "Router/Auth";
import PublicRoute from "Router/Public";
import ScreenRoute from "Router/Screen";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/beta/signup" element={<BetaSignUp />} />
        </Route>

        <Route element={<PublicRoute />}>
          <Route element={<Layout />}>
            <Route path="/signup" element={<SignUp />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/findId" element={<FindId />} />
          <Route path="/findPassword" element={<FindPassword />} />
        </Route>

        <Route element={<AuthRoute />}>
          <Route element={<Layout />}>
            <Route path="/" element={<Projects />} />
            <Route path="/project/:id" element={<Project />} />
          </Route>
        </Route>

        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/edit-password" element={<EditPassword />} />
        <Route path="/guide" element={<Guide />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
